webpackJsonp([217033713371477],{

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  0% {\n    top: -50px;\n    right: -30px;\n    opacity: 0;\n  }\n\n  100% {\n    top: 0px;\n    right: 0px;\n    opacity: 1;\n  }\n"], ["\n  0% {\n    top: -50px;\n    right: -30px;\n    opacity: 0;\n  }\n\n  100% {\n    top: 0px;\n    right: 0px;\n    opacity: 1;\n  }\n"]);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var styled_components_1 = __webpack_require__(12);
	var swoopIn = styled_components_1.keyframes(_templateObject);
	var style = "\n  position: relative;\n  animation-name: " + swoopIn + ";\n  animation-duration: 200ms;\n  animation-timing-function: cubic-bezier(0.42, 0, 0.57, 1.37);\n  animation-fill-mode: backwards;\n";
	exports.default = style;

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  & > a {\n    ", "\n  }\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  & > a {\n    ", "\n  }\n"]);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var styled_components_1 = __webpack_require__(12);
	var SkillListItem_1 = __webpack_require__(212);
	var itemAppear_1 = __webpack_require__(80);
	var Wrapper = styled_components_1.default.div(_templateObject, itemAppear_1.default);
	var SkillList = function SkillList(_ref) {
	  var skills = _ref.skills;
	  return React.createElement(Wrapper, null, skills && skills.map(function (skill, index) {
	    return React.createElement(SkillListItem_1.default, { key: skill.name, skill: skill, delay: index * 60 });
	  }));
	};
	exports.default = SkillList;

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n\n  height: 90px;\n  width: 300px;\n  margin: 10px;\n  padding: 10px;\n\n  background: #fff;\n\n  transition: all 0.3s cubic-bezier(.25,.8,.25,1);\n  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);\n\n  @media only screen and (max-width: 680px) {\n    height: 45px;\n    width: calc(50vw - 40px);\n    font-size: 14px;\n  }\n\n  &:hover {\n    box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);\n    transform: scale(1.05);\n  }\n"], ["\n  display: flex;\n\n  height: 90px;\n  width: 300px;\n  margin: 10px;\n  padding: 10px;\n\n  background: #fff;\n\n  transition: all 0.3s cubic-bezier(.25,.8,.25,1);\n  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);\n\n  @media only screen and (max-width: 680px) {\n    height: 45px;\n    width: calc(50vw - 40px);\n    font-size: 14px;\n  }\n\n  &:hover {\n    box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);\n    transform: scale(1.05);\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n"], ["\n  display: inline-block;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  max-height: 100%;\n"], ["\n  max-height: 100%;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  font-weight: bold;\n"], ["\n  font-weight: bold;\n"]);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var styled_components_1 = __webpack_require__(12);
	var Wrapper = styled_components_1.default.div(_templateObject);
	var Left = styled_components_1.default.div(_templateObject2);
	var Right = styled_components_1.default.div(_templateObject3);
	var Image = styled_components_1.default.img(_templateObject4);
	var Name = styled_components_1.default.span(_templateObject5);
	var SkillListItem = function SkillListItem(props) {
	  var _props$skill = props.skill,
	      name = _props$skill.name,
	      image = _props$skill.image,
	      link = _props$skill.link;
	
	  return React.createElement("a", { target: "_blank", href: link, style: { animationDelay: props.delay + "ms" } }, React.createElement(Wrapper, null, React.createElement(Left, null, React.createElement(Image, { src: image.publicURL })), React.createElement(Right, null, React.createElement(Name, null, name))));
	};
	exports.default = SkillListItem;

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var SkillList_1 = __webpack_require__(211);
	var page_1 = __webpack_require__(42);
	var GhostTyper_1 = __webpack_require__(59);
	var SkillsPage = function SkillsPage(_ref) {
	  var edges = _ref.data.allMarkdownRemark.edges;
	  return React.createElement(page_1.default, null, React.createElement("h1", null, "Skills"), React.createElement(GhostTyper_1.default, { text: "This list includes technologies that i have experience working with." }), React.createElement(SkillList_1.default, { skills: edges[0].node.frontmatter.skills }));
	};
	exports.pageQuery = "** extracted graphql fragment **";
	exports.default = SkillsPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-skills-tsx-a7c1b09acca8f0e07452.js